export default function socialServices() {
  return (
    [
      "vkontakte",
      "max",
      "telegram",
      "youtube",
      "rutube",
      "instagram",
      "zen",
      "whatsapp",
      "tiktok",
      "discord",
      "twitter",
      "habr",
      "rossgram",
      "tamtam",
      "yandexmessenger",
      "yappy",
      "yarus",
      "now",
      "facebook",
      "facebookmessenger",
      "odnoklassniki",
      "tenchat",
      "vimeo",
      "pinterest",
      "viber",
      "blogger",
      "icq",
      "meta",
      "googleplus",
      "tumblr",
      "reddit",
      "adfty",
      "amazon_wishlist",
      "arto",
      "att",
      "baidu",
      "blinklist",
      "blip",
      "blogmarks",
      "buddymarks",
      "buffer",
      "care2",
      "citeulike",
      "chiq",
      "corkboard",
      "dealsplus",
      "delicious",
      "digg",
      "diigo",
      "edmodo",
      "evernote",
      "fark",
      "fashiolista",
      "folkd",
      "foodlve",
      "friendfeed",
      "google_bmarks",
      "google_translate",
      "hatena",
      "instapaper",
      "jumptags",
      "kaboodle",
      "linkagogo",
      "linkedin",
      "livejournal",
      "mail_ru",
      "messenger",
      "moshare",
      "myspace",
      "n4g",
      "netlog",
      "netvouz",
      "newsvine",
      "nujij",
      "oknotizie",
      "segnalo",
      "sina",
      "sonico",
      "startaid",
      "startlap",
      "stumbleupon",
      "stumpedia",
      "typepad",
      "viadeo",
      "virb",
      "voxopolis",
      "xerpi",
      "xing",
      "yammer"
    ]
  )
}
